import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MdcDialogHeaderComponent, SharedUiModule } from '@mode/shared/ui';

import { SessionLoggedOutDialogComponent } from './session-logged-out-dialog/session-logged-out-dialog.component';
import { SessionExpiredInterceptor } from './session-expired.interceptor';
import { ButtonComponent } from '@mode/capra';

@NgModule({
  imports: [ButtonComponent, CommonModule, SharedUiModule, MatDialogModule, MdcDialogHeaderComponent],
  declarations: [SessionLoggedOutDialogComponent],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: SessionExpiredInterceptor, multi: true }],
})
export class SessionsFeatureSessionModule {}
